export default {
  importFromExcel: 'Import from Excel',
  downloadTheTemplate: 'Download the template',
  uploadTheFile: 'Upload the file',
  finish: 'Finish',
  clickTheIconToDownloadTheTemplateFill:
    'Click the icon to download the template, fill in the information If the download is complete, click',
  next: 'Next',
  uploadTheFileTwo: ' You can only upload one file at a time, or',
  clickUpload: 'Click Upload',
  downloadTheResults: 'View the import results',
  theUploadIsSuccessful: 'The upload is successful',
  cancel: 'Cancel',
  previousStep: 'Previous step',
  theImportToExcelIsSuccessful: 'The import to Excel is successful',
  success: 'success',
  items: 'items',
  failed: 'failed',
  fileSizeMax: 'The file size cannot exceed',
  fileFormatError: 'The file format error, please upload',
  file: 'file',
}
